import { MAZE_CONFIG } from './config';

/**
 * Initialize Maze user testing snippet
 * Dynamically injects the Maze Universal Snippet for live website testing
 */
export const initMaze = (): void => {
  // Check if Maze is enabled in config
  if (!MAZE_CONFIG.enabled) {
    console.log('[Maze] Disabled in config');
    return;
  }

  // Check if already loaded
  if ((window as any).mazeUniversalSnippetApiKey) {
    console.log('[Maze] Already initialized');
    return;
  }

  console.log('[Maze] Initializing...');

  // Maze Universal Snippet
  (function (m: any, a: Document, z: string, e: string) {
    var s: HTMLScriptElement, t: string | null, u: HTMLScriptElement | null, v: string | undefined;
    
    try {
      t = m.sessionStorage.getItem('maze-us');
    } catch (err) {
      t = null;
    }

    if (!t) {
      t = new Date().getTime().toString();
      try {
        m.sessionStorage.setItem('maze-us', t);
      } catch (err) {
        // Ignore storage errors
      }
    }

    u = document.currentScript as HTMLScriptElement || (function () {
      var w = document.getElementsByTagName('script');
      return w[w.length - 1] as HTMLScriptElement;
    })();
    v = u && u.nonce;

    s = a.createElement('script');
    s.src = z + '?apiKey=' + e;
    s.async = true;
    if (v) s.setAttribute('nonce', v);
    a.getElementsByTagName('head')[0].appendChild(s);
    m.mazeUniversalSnippetApiKey = e;
  })(window, document, 'https://snippet.maze.co/maze-universal-loader.js', MAZE_CONFIG.apiKey);

  console.log('[Maze] Snippet injected');
};

/**
 * Unload Maze snippet
 * Removes the Maze script and cleans up references
 */
export const unloadMaze = (): void => {
  // Remove the script tag
  const scripts = document.querySelectorAll('script[src*="maze.co"]');
  scripts.forEach(script => script.remove());

  // Clean up global reference
  delete (window as any).mazeUniversalSnippetApiKey;

  console.log('[Maze] Unloaded');
};

/**
 * Check if running in test mode
 */
export const isTestMode = (): boolean => {
  const params = new URLSearchParams(window.location.search);
  return params.get('test') === 'true';
};
